import { createAppAsyncThunk } from "Store/createAppAsyncThunk";

import logger from "Libs/logger";

import { getGitDiffRequest } from "Api/git/getGitDiff.request";
import { GitDiff, GitDiffProps } from "../types";

export const loadGitDiff = createAppAsyncThunk<GitDiff[], GitDiffProps>(
  "gitDiffs/load",
  async ({ projectId, left, right, glob }, { rejectWithValue }) => {
    try {
      const gitDiff = await getGitDiffRequest({ projectId, left, right, glob });

      return gitDiff;
    } catch (err: unknown) {
      const error =
        (err as { title: string })?.title ??
        (err as { description: string })?.description ??
        "An error has occurred";

      logger(err, {
        action: "gitDiffs/load"
      });

      return rejectWithValue({ error });
    }
  },
  {
    condition: ({ left, right }, { getState }) => {
      const key = `${left}:${right}`;
      const existing = getState().gitDiffs.data[key];
      if (existing?.data || existing?.isLoading) {
        return false;
      }
    }
  }
);
